import axios from 'axios';

let rpcId = 1;

class RPCError extends Error {
  constructor(type, raw, path, request, ...params) {
    super(...params);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, RPCError);
    }

    this.name = 'RPC Error';
    this.path = path;
    this.type = type;
    this.request = request;
    this.raw = raw;
  };
}

function RPC(path, method, params = null) {
  let request = {
    jsonrpc: '2.0',
    method,
    params,
    id: (rpcId++).toString()
  };
  return new Promise((resolve, reject) => {
    let RpcPath = path;
    if (!/^https?:/.test(path)) {
      RpcPath = `/rest/user/${path}`;
    }
    axios.post(RpcPath, request)
      .then(response => {
        if (response.data.hasOwnProperty('error')) {
          console.error('RPC call Error', path, request, response.data);
          reject(new RPCError('RPC', response.data, path, request, response.data.error.message));
        } else {
          resolve(response.data.result);
        }
      })
      .catch(e => {
        console.error('RPC call HTTP Error', path, request, e);
        reject(new RPCError('HTTP', e.data, path, request, e.message));
      });
  });
};

export { RPC };
